"use client";

import * as React from "react";

import "./styles/global.css";

import { ThemeProvider } from "./components/core/theme-provider";
import { Toaster } from "./components/core/toaster";
import { SettingsProvider } from "./components/core/settings/settings-context";

export interface RootProps {
  children: React.ReactNode;
}

export function Root({ children }: RootProps): React.JSX.Element {
  return (
    <SettingsProvider settings={{}}>
      <ThemeProvider>
        {children}
        <Toaster position="bottom-right" richColors />
      </ThemeProvider>
    </SettingsProvider>
  );
}
